<template>
  <two-sides-modal
    v-model="dialog"
    title="Detalle POP"
    subtitle="Detalle POP"
    icon="mdi-list-box-outline"
    height="auto"
    :persistent="loading"
  >
    <table-toolbar
      class="mt-3"
      hide-delete
      :search="search"
      :selected-items="selectedItems"
      :downloading="downloading"
      @refresh="getRebateDetail()"
      @update:search="(e) => (search = e)"
      @export="exportSelected"
    />
    <pop-detail-table
      :data="data"
      :loading="loading"
      :search="search"
      :headers="headers"
      @itemSelected="onItemSelected"
    />
  </two-sides-modal>
</template>
<script>
  import TwoSidesModal from '@/components/modals/TwoSidesModal.vue';
  import TableToolbar from '@/components/tables/TableToolbar.vue';
  import PopDetailTable from './components/PopDetailTable.vue';
  import { useExcelExport } from '@/utilities/useExcelExport';

  export default {
    name: 'PopBonusDetail',
    components: { TwoSidesModal, TableToolbar, PopDetailTable },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      data: {
        type: Object,
        default: () => {},
      },
      loading: Boolean,
    },
    data() {
      return {
        search: '',
        selectedItems: [],
        downloading: false,
        headers: [
          { text: 'Factura', value: 'FACTURA', exportable: true },
          { text: 'Nota de crédito', value: 'NTC', exportable: true },
          { text: 'Fecha de nota', value: 'FENTC', exportable: true },
          { text: 'Importe', value: 'IMPORTE', exportable: true },
          { text: '', value: 'data-table-select', exportable: false },
        ],
      };
    },
    computed: {
      dialog: {
        set(newVal) {
          this.$emit('input', newVal);
        },
        get() {
          return this.value;
        },
      },
    },
    created() {
      this.excel = useExcelExport();
    },
    methods: {
      onItemSelected(items) {
        this.selectedItems = items;
      },
      async exportSelected() {
        await this.excel.exportExcel({
          headers: this.headers,
          items: this.selectedItems,
          filename: 'pop.xlsx',
        });
      },
      getRebateDetail(event) {
        this.$emit('refresh', event);
      },
    },
  };
</script>
